import React, { useContext, useState } from "react";
import { PublicDataContext } from "pages/PublicData";

const NativeSignUp = ({ initialState, callback, cancel }) => {
  const publicDataContext = useContext(PublicDataContext);

  const [formData, _setFormData] = useState({
    email: initialState?.email || "",
    name: initialState?.name || "",
    password: "",
    verifyPassword: "",
    gdprConsent: false,
    ageVerified: false,
  });
  const setFormData = (insert) => {
    _setFormData({ ...formData, ...insert });
  };

  return (
    <div
      style={{
        // width: "300px",
        margin: "0 auto",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <h2
        style={{
          marginBottom: 30,
          marginTop: 0,
        }}
      >
        Sign Up
      </h2>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          marginBottom: "10px",
        }}
      >
        <div>
          <div>
            <div>
              <input
                type='text'
                placeholder='Name*'
                autoComplete='username'
                value={formData.name}
                onChange={(e) => setFormData({ name: e.target.value })}
                style={{
                  width: "100%",
                  marginBottom: "10px",
                  padding: "10px",
                  border: "1px solid #436c9a",
                  borderRadius: "5px",
                }}
              />
            </div>
            <div>
              <input
                type='email'
                placeholder='Email*'
                autoComplete='email'
                value={formData.email}
                onChange={(e) => setFormData({ email: e.target.value })}
                style={{
                  width: "100%",
                  marginBottom: "10px",
                  padding: "10px",
                  border: "1px solid #436c9a",
                  borderRadius: "5px",
                }}
              />
            </div>
            <div>
              <input
                type='password'
                placeholder='Password*'
                autoComplete='new-password'
                value={formData.password}
                onChange={(e) => setFormData({ password: e.target.value })}
                style={{
                  width: "100%",
                  marginBottom: "10px",
                  padding: "10px",
                  border: "1px solid #436c9a",
                  borderRadius: "5px",
                }}
              />
            </div>
            <div>
              <input
                type='password'
                placeholder='Verify Password*'
                autoComplete='current-password'
                value={formData.verifyPassword}
                onChange={(e) =>
                  setFormData({ verifyPassword: e.target.value })
                }
                style={{
                  width: "100%",
                  marginBottom: "10px",
                  padding: "10px",
                  border: "1px solid #436c9a",
                  borderRadius: "5px",
                }}
              />
            </div>
            <div
              style={{
                height: 1,
                width: "100%",

                background: "#aaa",
                marginTop: 10,
                marginBottom: 5,
              }}
            ></div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  padding: "10px",
                  // border: '1px solid #436c9a',
                  borderRadius: "5px",
                }}
              >
                <input
                  type='checkbox'
                  value={formData.ageVerified}
                  onClick={(e) =>
                    setFormData({ ageVerified: e.target.checked })
                  }
                  style={{ marginRight: "10px" }}
                />
                <label htmlFor='gdpr'>I am 14 years of age or older</label>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  marginBottom: "10px",
                  padding: "10px",
                  // border: '1px solid #436c9a',
                  borderRadius: "5px",
                }}
              >
                <input
                  type='checkbox'
                  value={formData.gdprConsent}
                  onClick={(e) =>
                    setFormData({ gdprConsent: e.target.checked })
                  }
                  style={{ marginRight: "10px" }}
                />
                <label htmlFor='gdpr'>
                  I agree to the{" "}
                  <a
                    style={{
                      color: "#436c9a",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      publicDataContext.setShowTermsOfUse(true);
                    }}
                  >
                    Terms of Use
                  </a>{" "}
                  and{" "}
                  <a
                    style={{
                      color: "#436c9a",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      publicDataContext.setShowPrivacyPolicy(true);
                    }}
                  >
                    Privacy & Cookies Policy
                  </a>
                </label>
              </div>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  callback(formData);
                }}
                disabled={
                  !(
                    formData.name &&
                    formData.ageVerified &&
                    formData.email &&
                    formData.password &&
                    formData.verifyPassword &&
                    formData.gdprConsent
                  )
                }
                style={{
                  background:
                    formData.name &&
                    formData.ageVerified &&
                    formData.email &&
                    formData.password &&
                    formData.verifyPassword &&
                    formData.gdprConsent
                      ? "#436c9a"
                      : "grey",
                  padding: 10,
                  borderRadius: 10,
                  border: "none",
                  width: "50%",
                  color: "#fff",
                  marginBottom: "10px",
                }}
              >
                Create Account
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NativeSignUp;
